module.exports = __webpack_public_path__ + "img/1536656345.36a438c2.jpg";